import {Feature} from "@/models/backend/FeatureModels";
import {Filter} from "@/models/frontend/FeatureModels";

/**
 * Transform features from the backend to frontend filters.
 * @param {Feature[]} features - List of backend features
 * @returns {Filter[]} - Transformed filters for the frontend
 */
export function transformFeaturesToFilters(features: Feature[]): Filter[] {
    return features.map((feature) => {
        const options =
            feature.type === 'MULTIVALUE' || feature.type ==='ENUMERATION'
                ? feature.values.map((value : any) => ({
                    label: value.value,
                    value: value.id,
                }))
                : undefined;

        return {
            id: "feature-" + feature.id,
            type: 'dropdown-multiselect', // Assume MULTIVALUE maps to dropdown-multiselect
            label: feature.label,
            placeholder: 'Selecciona',
            options,
            value: [],
            defaultValue: [],
            clearable: true,
        };
    });
}


export const transformFeaturesToDict = (features: Feature[]) => {
    const featureDict: Record<string, string> = {};

    features.forEach(feature => {
        if (Array.isArray(feature.values)) {
            feature.values.forEach(value => {
                featureDict[value.id] = value.value;
            });
        }
    });

    return featureDict;
};

export const transformTemplateFeatures = (features: Feature[]) => {
    const transformedFeatures = features.map(feature => ({
        id: feature.id,
        type: feature.type === 'MULTIVALUE' ? 'multiSelect' : 'singleSelect',
        label: feature.label,
        selected: null,
        values: feature.values.map(value => ({
            value: value.id,
            label: value.value
        })),
        placeholder: 'Selecciona',
        name: feature.name
    }));


    //Group features into rows of three
    const groupedFeatures = [];
    for (let i = 0; i < transformedFeatures.length; i += 3) {
        groupedFeatures.push(transformedFeatures.slice(i, i + 3));
    }

    return groupedFeatures;
};